// Users
export const GET_USER = 'GET_USER'
export const GET_USERS = 'GET_USERS'

// Auth
export const GET_AUTH_TOKEN = 'GET_AUTH_TOKEN'
export const GET_AUTH_USER = 'GET_AUTH_USER'
export const DELETE_AUTH_TOKEN = 'DELETE_AUTH_TOKEN'
export const DELETE_AUTH_USER = 'DELETE_AUTH_USER'
export const DELETE_GOOGLE_TOKEN = 'DELETE_GOOGLE_TOKEN'

// Delete user
export const DELETE_USER = 'ADD_USER'

// Create user
export const ADD_USER = 'ADD_USER'
export const REQUEST_ADD_USER = 'REQUEST_ADD_USER'

// Update user
export const UPDATE_USER = 'UPDATE_USER'
export const REQUEST_UPDATE_USER = 'REQUEST_UPDATE_USER'

//
// XHR
//
export const ERROR_XHR = 'ERROR_XHR'
export const SUCCESS_XHR = 'SUCCESS_XHR'

//
// Meetings
//
export const GET_MEETINGS = 'GET_MEETINGS'
export const GET_MEETINGS_FOR_CONTACT = 'GET_MEETINGS_FOR_CONTACT'
export const GET_MEETINGS_FOR_PROJECT = 'GET_MEETINGS_FOR_PROJECT'
export const GET_MEETING = 'GET_MEETING'
// Add
export const REQUEST_ADD_MEETING = 'REQUEST_ADD_MEETING'
export const SUCCESS_ADD_MEETING = 'SUCCESS_ADD_MEETING'
// Update
export const REQUEST_UPDATE_MEETING = 'REQUEST_UPDATE_MEETING'
export const SUCCESS_UPDATE_MEETING = 'SUCCESS_UPDATE_MEETING'
// Delete
export const REQUEST_DELETE_MEETING = 'REQUEST_DELETE_MEETING'
export const SUCCESS_DELETE_MEETING = 'SUCCESS_DELETE_MEETING'

//
// Calendar
//
export const SELECT_DAY = 'SELECT_DAY'
export const SELECT_CALENDAR_USERS = 'SELECT_CALENDAR_USERS'
export const TOGGLE_CALENDAR_USER = 'TOGGLE_CALENDAR_USER'

//
// Contacts
//
export const GET_CONTACT = 'GET_CONTACT'
export const GET_CONTACTS = 'GET_CONTACTS'
export const GET_PROJECTS_OF_CONTACT = 'GET_PROJECTS_OF_CONTACT'
export const GET_SOCIAL_STATUSES_OF_CONTACT = 'GET_SOCIAL_STATUSES_OF_CONTACT'
export const GET_CONTRACT_TYPES = 'GET_CONTRACT_TYPES'
export const GET_CONTRACT_TYPES_OF_CONTACT = 'GET_CONTRACT_TYPES_OF_CONTACT'
export const GET_PROBLEMATIQUES_OF_CONTACT = 'GET_PROBLEMATIQUES_OF_CONTACT'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_TRACKING_PLACES = 'GET_TRACKING_PLACES'
export const GET_REFERENT_ADVISERS = 'GET_REFERENT_ADVISERS'
export const ADD_CONTACT = 'ADD_CONTACT'
export const REQUEST_ADD_CONTACT = 'REQUEST_ADD_CONTACT'
export const REQUEST_DELETE_CONTACT = 'REQUEST_DELETE_CONTACT'
export const DELETE_CONTACT = 'DELETE_CONTACT'
export const UPDATE_CONTACT = 'UPDATE_CONTACT'
export const REQUEST_UPDATE_CONTACT = 'REQUEST_UPDATE_CONTACT'
// Sub sectors
export const GET_SUB_SECTORS = 'GET_SUB_SECTORS'

//
// Google
//
export const GET_GOOGLE_AUTH_URL = 'GET_GOOGLE_AUTH_URL'
export const GET_GOOGLE_TOKEN = 'GET_GOOGLE_TOKEN'

//
// Issues
//
export const GET_ISSUES = 'GET_ISSUES'

//
// Family situations
//
export const GET_FAMILY_SITUATIONS = 'GET_FAMILY_SITUATIONS'

//
// Partner situations
//
export const GET_PARTNER_SITUATIONS = 'GET_PARTNER_SITUATIONS'

//
// Social statuses
//
export const GET_SOCIAL_STATUSES = 'GET_SOCIAL_STATUSES'

//
// Problematiques
//
export const GET_PROBLEMATIQUES = 'GET_PROBLEMATIQUES'

//
// Allowances
//
export const GET_ALLOWANCES = 'GET ALLOWANCES'

//
// Sectors
//
export const GET_SECTORS = 'GET_SECTORS'

//
// EDUCATION_LEVELS
//
export const GET_EDUCATION_LEVELS = 'GET_EDUCATION_LEVELS'

// Presences
//
export const GET_PRESENCES = 'GET_PRESENCES'

// Phases
//
export const GET_PHASES = 'GET_PHASES'

// CONTENTS
//
export const GET_CONTENTS = 'GET_CONTENTS'

// PLACES
//
export const GET_PLACES = 'GET_PLACES'

// TRAININGS
//
export const GET_TRAININGS = 'GET_TRAININGS'

// Intervenant 1
//
export const GET_FIRSTINTERVENANTS = 'GET_FIRSTINTERVENANTS'

//
// incubatorRewards
//
export const GET_INCUBATOR_REWARDS = 'GET_INCUBATOR_REWARDS'

//
// Companies
//
export const GET_COMPANIES = 'GET_COMPANIES'
export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const ADD_COMPANY = 'ADD_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const REQUEST_COMPANY = 'REQUEST_COMPANY'
export const REQUEST_COMPANY_GET = 'REQUEST_COMPANY_GET'

//
// Job
//
export const GET_JOB = 'GET_JOB'
export const UPDATE_JOB = 'UPDATE_JOB'
export const ADD_JOB = 'ADD_JOB'
export const DELETE_JOB = 'DELETE_JOB'
export const REQUEST_JOB = 'REQUEST_JOB'

//
// Course
//
export const GET_COURSES = 'GET_COURSES'
export const UPDATE_COURSE = 'UPDATE_COURSE'
export const ADD_COURSE = 'ADD_COURSE'
export const DELETE_COURSE = 'DELETE_COURSE'
export const REQUEST_COURSE = 'REQUEST_COURSE'

export const GET_COURSE_TYPES = 'GET_COURSE_TYPES'
export const GET_STRUCTURE_TYPES = 'GET_STRUCTURE_TYPES'
export const GET_STATUT_ENTREPRENEURS = 'GET_STATUT_ENTREPRENEURS'
export const GET_TAX_REGIMES = 'GET_TAX_REGIMES'
export const GET_WELFARE_REGIMES = 'GET_WELFARE_REGIMES'
export const GET_EMPLOYMENTS = 'GET_EMPLOYMENTS'

// Projects
export const GET_PROJECT = 'GET_PROJECT'
export const GET_PROJECTS = 'GET_PROJECTS'
// Delete project
export const DELETE_PROJECT = 'DELETE_PROJECT'
export const REQUEST_DELETE_PROJECT = 'REQUEST_DELETE_PROJECT'
// Create project
export const ADD_PROJECT = 'ADD_PROJECT'
export const REQUEST_ADD_PROJECT = 'REQUEST_ADD_PROJECT'
// Update project
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const REQUEST_UPDATE_PROJECT = 'REQUEST_UPDATE_PROJECT'

export const GET_PROJECT_TYPES = 'GET_PROJECT_TYPES'
export const GET_PROJECT_STATUS = 'GET_PROJECT_STATUS'
// CAPE
export const GET_CAPE = 'GET_CAPE'
export const UPDATE_CAPE = 'UPDATE_CAPE'
export const ADD_CAPE = 'ADD_CAPE'
export const DELETE_CAPE = 'DELETE_CAPE'
export const REQUEST_CAPE = 'REQUEST_CAPE'
// CER
export const GET_CER = 'GET_CER'
export const UPDATE_CER = 'UPDATE_CER'
export const ADD_CER = 'ADD_CER'
export const DELETE_CER = 'DELETE_CER'
export const GET_INSTRUCTORS = 'GET_INSTRUCTORS'
export const GET_PRESCRIPTORS = 'GET_PRESCRIPTORS'
export const REQUEST_CER = 'REQUEST_CER'
// SORTIE
export const GET_SORTIE = 'GET_SORTIE'
export const UPDATE_SORTIE = 'UPDATE_SORTIE'
export const ADD_SORTIE = 'ADD_SORTIE'
export const DELETE_SORTIE = 'DELETE_SORTIE'
// CLUB
export const GET_CLUB = 'GET_CLUB'
export const UPDATE_CLUB = 'UPDATE_CLUB'
export const ADD_CLUB = 'ADD_CLUB'
export const DELETE_CLUB = 'DELETE_CLUB'
// CAE
export const GET_CAE = 'GET_CAE'
export const UPDATE_CAE = 'UPDATE_CAE'
export const ADD_CAE = 'ADD_CAE'
export const DELETE_CAE = 'DELETE_CAE'




// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js